var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{class:{ 'form-submitting': _vm.isSubmitting },on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }